import React, { Children } from 'react';
import { withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import AddCircle from '@material-ui/icons/AddCircle';
import { NavLink } from 'react-router-dom';
import { Calendar, Views, momentLocalizer } from 'react-big-calendar';
import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import _ from 'lodash';
import { connect } from 'react-redux';
import { resourceMap, styles } from '../shared/imports';

const CustomMonthContainer = ({ currentUser, deleteEvent }) => props => {
	return <MonthEvent event={props} currentUser={currentUser} deleteEvent={deleteEvent} />;
};

const CustomDayContainer = ({ currentUser, deleteEvent }) => props => {
	return <Event event={props} currentUser={currentUser} deleteEvent={deleteEvent} />;
};

const Event = React.memo(props => {
	return (
		<span>
			<strong>{props.event.event.title}</strong>
		</span>
	);
});

const MonthEvent = React.memo(props => {
	return (
		<span className="event" style={{ display: 'flex', justifyContent: 'space-between' }} title={props.event.event.user_note}>
			<span className="person">
				{props.event.event.description === 'Down Under' ? <span className="location">DU</span> : props.event.event.description === 'Back Bar' ? <span className="location">Back</span> : props.event.event.description === 'Bouncer' ? <span className="location">Security</span> : <span className="location">{props.event.event.description}</span>}: {props.event.event.user_firstname}
			</span>
			{props.event.event.note !== '' && <span className="note">{props.event.event.note}</span>}
		</span>
	);
});

const mapStateToProps = (state, props) => {
	return {
		user: state.auth.user,
	};
};

const DragAndDropCalendar = withDragAndDrop(Calendar);
const localizer = momentLocalizer(moment);

class ViewCal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			events: [],
			resource: 0,
			holidays: [],
		};
	}

	componentDidMount() {
		//this.getEvents();
		this.nav(
			moment()
				.startOf('month')
				.startOf('week'),
			moment()
				.endOf('month')
				.endOf('week')
		);
		this.getHolidays();
	}

	nav = (start, end) => {
		this.setState({ dummyStart: start, dummyEnd: end });
		let url = '/api/getMonthEvents';
		let that = this;
		let mongostart = start.toDate();
		let mongoend = end.toDate();
		axios({
			method: 'post',
			url: url,
			data: { start: mongostart, end: mongoend, unpublished: this.props.user.unpublished },
		}).then(function(response) {
			console.log('new monthly events:', response);
			_.each(response.data, function(v) {
				v.start = moment(v.start).toDate();
				v.end = moment(v.end).toDate();
			});
			that.setState({
				events: response.data,
			});
		});
	};

	getHolidays = () => {
		axios({
			method: 'get',
			url: '/api/getHolidays',
		}).then(response => {
			if (response.data) {
				console.log('holidays found:', response);
				let holidays = [];
				_.each(response.data, t => {
					holidays.push({ date: t.date, title: t.name });
				});
				this.setState({ holidays: holidays });
			}
		});
	};

	getEvents = () => {
		let that = this;
		let mongostart = this.state.dummyStart.toDate();
		let mongoend = this.state.dummyEnd.toDate();
		let id = this.state.resource;
		let url = '/api/getScheduleByResource';

		axios({
			method: 'post',
			url: url,
			data: { start: mongostart, end: mongoend, id: id, unpublished: this.props.user.unpublished },
		}).then(function(response) {
			console.log('response.data', response.data);
			_.each(response.data, function(v) {
				v.start = moment(v.start).toDate();
				v.end = moment(v.end).toDate();
			});
			that.setState({
				events: _.reject(response.data, function(el) {
					//console.log("this is el", el.title);
					return el.user_firstname === undefined;
				}),
			});
		});
		/*
    fetch('/api/getSchedule')
    .then(res => res.json())
    //.then(list => console.log("res:", list))
    .then(list => {
      _.each(list, function(v){
        v.start = moment(v.start).toDate();
        v.end = moment(v.end).toDate();
      });
      this.setState({ events: list })
      console.log("this is the list", list);
    })*/
	};

	switchView = id => {
		this.setState({ resource: id }, () => this.getEvents());
	};

	render() {
		const items = this.state.list;
		const { classes } = this.props;
		let id = '';
		return (
			<div>
				<h1 className={classes.h1}>{_.find(resourceMap, ['resourceId', this.state.resource]) ? _.find(resourceMap, ['resourceId', this.state.resource]).title : 'Everywhere'} Calendar</h1>
				<h4>
					<span onClick={() => this.switchView(0)}>Everywhere</span>
					{resourceMap.map(r => {
						return (
							<span className="spaceout" onClick={() => this.switchView(r.resourceId)}>
								{r.title}
							</span>
						);
					})}
				</h4>

				<DragAndDropCalendar
					startAccessor="start"
					endAccessor="end"
					localizer={localizer}
					views={{
						month: true,
						week: false,
						day: false,
					}}
					onNavigate={(date, view) => {
						let start, end;

						if (view === 'month') {
							start = moment(date)
								.startOf('month')
								.startOf('week');
							end = moment(date)
								.endOf('month')
								.endOf('week');
							this.nav(start, end);
						}
					}}
					onView={view => {
						if (view === 'day') {
							var header = document.getElementsByClassName('rbc-toolbar')[0];
							var sticky = header.offsetTop - 100;
							window.onscroll = function() {
								if (window.pageYOffset > sticky) {
									header.classList.add('rbc-toolbar-fixed');
									if (document.getElementsByClassName('rbc-time-header')) document.getElementsByClassName('rbc-time-header')[0].classList.add('time-header-fixed');
								} else {
									header.classList.remove('rbc-toolbar-fixed');
									if (document.getElementsByClassName('rbc-time-header')) document.getElementsByClassName('rbc-time-header')[0].classList.remove('time-header-fixed');
								}
							};
						}
					}}
					events={this.state.events}
					style={{ height: 1000, width: '95%' }}
					defaultView={Views.MONTH}
					scrollToTime={new Date(1970, 1, 1, 6)}
					defaultDate={new Date()}
					resources={resourceMap}
					resourceIdAccessor="resourceId"
					resourceTitleAccessor="resourceTitle"
					components={{
						dateCellWrapper: ({ children, value }) => {
							return React.cloneElement(Children.only(children), {
								style: {
									...children.style,
									backgroundColor: this.state.holidays.findIndex(x => x.date === moment(value).format('YYYY-MM-DD')) >= 0 ? '#ffe8e8' : '#fff',
									border: this.state.holidays.findIndex(x => x.date === moment(value).format('YYYY-MM-DD')) >= 0 ? '1px solid #7e1f1f' : null,
								},
							});
						},
						month: {
							event: CustomMonthContainer({
								currentUser: this.props.user._id,
								deleteEvent: this.deleteEvent,
							}),
							dateHeader: props => {
								console.log(props);
								let index = this.state.holidays.findIndex(x => x.date === moment(props.date).format('YYYY-MM-DD'));
								return (
									<div style={{ display: 'flex', justifyContent: 'space-between' }}>
										{index >= 0 && <span style={{ fontSize: '11pt', color: '#610c0c', fontWeight: 'bold' }}>{this.state.holidays[index].title}</span>}
										<span>{props.label}</span>
									</div>
								);
							},
						},
						day: {
							event: CustomDayContainer({
								currentUser: this.props.user._id,
								deleteEvent: this.deleteEvent,
							}),
						},
					}}
					eventPropGetter={event => {
						const backgroundColor = _.find(resourceMap, ['resourceId', event.resourceId]).color;
						let position = '';
						let top = '0';
						if (event.description === 'Bouncer') {
							let count = this.state.events.filter(d => moment(d.start).format('YYYY-MM-DD') === moment(event.start).format('YYYY-MM-DD')).length;
							position = 'relative';
							switch (count) {
								case 3:
									top = '92px';
									break;

								case 4:
									top = '67px';
									break;

								case 5:
									top = '40px';
									break;

								case 6:
									top = '15px';
									break;
							}
							//top = 85 - (count - 3) * 20 + 'px';
						}
						const styles = { backgroundColor, position, top };
						return { style: styles };
					}}
				/>
			</div>
		);
	}
}
//this can be a calendar prop
//onSelectEvent={event => alert(event.title)}
const ViewCalendar = withStyles(styles, { withTheme: true })(ViewCal);
export default connect(mapStateToProps)(ViewCalendar);
